module.exports = __webpack_public_path__ + "img/V29.315c20ae.jpg";